// extracted by mini-css-extract-plugin
module.exports = {"root":"EducationHeader__root--2EEMF","text":"EducationHeader__text--3fKwG","bounce":"EducationHeader__bounce--39tWV"};